import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
} from '@angular/core';
import { HTMLSanitiser } from '../sanitise-raw-html';

/**
 * Renders customer-provided raw HTML inside a Shadow Root so that:
 * - `<style>` blocks and CSS in the raw HTML can't leak into the app.
 * - Application styles can't distort the preview.
 *
 * The HTML is sanitised via DOMPurify before it touches the DOM.
 */
@Component({
  selector: 'pt-raw-html-preview',
  template: '',
  host: { class: 'block overflow-auto' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RawHtmlPreviewComponent {
  private _shadowRoot: ShadowRoot;

  constructor(elementRef: ElementRef<HTMLElement>) {
    this._shadowRoot = elementRef.nativeElement.attachShadow({ mode: 'open' });
  }

  @Input()
  set html(html: string | null | undefined) {
    this._shadowRoot.innerHTML = HTMLSanitiser.sanitise(html ?? '');
  }
}
